import { AppModules } from 'appContainer/types';
import { PathRouteContent, RouteNode } from 'router/declarative/routeNode';

export const routes = {
  path: '/analytics',
  title: 'Analytics Overview',
  appModule: AppModules.ANALYTICS,
  content: async (): PathRouteContent =>
    (await import('./AnalyticsContainer')).AnalyticsContainer,
  children: [],
} as const satisfies RouteNode;
